import { DataService } from './dataService'

export const destinationService = {
    importLocalTariffData: async (data) => {
        return DataService.post('/admin/import_local_tariff_data', data)
    },
    exportLocalTariffData: async (data) => {
        return DataService.get('/admin/export_local_tariff_data', data)
    },

    getLocaltariffs: async (data) => {
        return DataService.get('/admin/get_localtariffs', data)
    },

    getAirDestinationtariffs: async (data) => {
        return DataService.get('admin/get_destinationratesair', data)
    },
    
    getSeaDestinationtariffs: async (data) => {
        return DataService.get('admin/get_destinationratessea', data)
    },

    //air

    importAirTariffData: async (data) => {
        return DataService.post('/admin/import_destinationratesair_data', data)
    },
    exportAirTariffData: async (data) => {
        return DataService.get('/admin/export_destinationratesair_data', data)
    },
    getAirtariffs: async (data) => {
        return DataService.get('/admin/get_localtariffs', data)
    },

    importSeaTariffData: async (data) => {
        return DataService.post('/admin/import_seafreights_data', data)
    },
    exportSeaTariffData: async (data) => {
        return DataService.get('/admin/export_seafreights_data', data)
    },
    getSeatariffs: async (data) => {
        return DataService.get('/admin/get_localtariffs', data)
    },

    /// below api sea destination

    exportSeaDestinationData: async (data) => {
        return DataService.get('/admin/export_destinationratessea_data', data)
    },

    importSeaDestinationData: async (data) => {
        return DataService.post('/admin/import_destinationratessea_data', data)
    },

    // consolidation 

    getAirDestinationConsolidationtariffs: async (data) => {
        return DataService.get('admin/get_dest_charge_air_consolidation', data)
    },
    
    getSeaDestinationConsolidationtariffs: async (data) => {
        return DataService.get('admin/get_dest_charge_sea_consolidation', data)
    },
    importAirConsolidationTariffData: async (data) => {
        return DataService.post('/admin/import_dest_charge_air_consolidation', data)
    },
    exportAirConsolidationTariffData: async (data) => {
        return DataService.get('/admin/export_dest_charge_air_consolidation', data)
    },

    importSeaConsolidationTariffData: async (data) => {
        return DataService.post('/admin/import_dest_charge_sea_consolidation', data)
    },
    exportSeaConsolidationTariffData: async (data) => {
        return DataService.get('/admin/export_dest_charge_sea_consolidation', data)
    }
}



